<template>
    <div>
        <Filters :categories="categories" @update-filters="handleFilters" @open-modal="$emit('open-modal')"
            :fields="fields" :permissionEdit="permissionEdit" />

        <DataTable :columns="columns" :data="tableData" :pagination="pagination" @page-change="handlePageChange"
            @size-change="handleSizeChange" @edit="handleEdit" @change-status="handleStatus" />

        <DynamicFormModal v-if="showModal" :fields="fields" :form-data="formData" @close="$emit('close-modal')"
            @submit="handleSubmit" :title="title" />
    </div>
</template>

<script>
import Filters from "./Filters.vue";
import DataTable from "./DataTable.vue";
import DynamicFormModal from "./DynamicFormModal.vue";

export default {
    name: "ReusableDynamicModule",
    components: {
        Filters,
        DataTable,
        DynamicFormModal,
    },
    props: {
        categories: {
            type: Array,
            required: true,
        },
        columns: {
            type: Array,
            required: true,
        },
        tableData: {
            type: Array,
            required: true,
        },
        fields: {
            type: Array,
            required: true,
        },
        pagination: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
            default: "Formulario",
        },
        showModal: {
            type: Boolean,
            default: false
        },
        formData: {
            type: Object,
            default: () => ({})
        },
        permissionEdit: {
            type: String,
            required: false,
        },
    },
    methods: {
        handleFilters({ category_id }) {
            this.$emit("update-filters", { category_id });
        },
        handlePageChange(page) {
            this.$emit("page-change", page);
        },
        handleSizeChange(size) {
            this.$emit("size-change", size);
        },
        handleEdit(item) {
            this.$emit("edit-item", item);
        },
        handleStatus(item) {
            this.$emit("change-status", item);
        },
        handleSubmit(data) {
            this.$emit("submit-data", data);
        }
    },
};
</script>
